<template>
  <div class="AnswerText">

    <pre class="AnswerText-text"
      v-if="content.text"
      v-html="content.text">
    </pre>

    <img class="AnswerText-image" :src="content.image" />

  </div>
</template>

<script>
export default {
  name: 'AnswerText',

  props: {
    content: {
      type: Object,
      required: true
    }
  }
}
</script>

<style>
.AnswerText {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  max-width: 652px;
  text-align: center;
}

.AnswerText-image {
  display: block;
  margin-top: 2rem;
  max-height: 273px;
}

.AnswerText-text {
  width: 652px;
}
</style>



// WEBPACK FOOTER //
// AnswerText.vue?deb406b8